import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });
client.interceptors.request.use((config) => {
  const params = config.params || {};
  if (params.pin) {
    config.headers = config.headers || {};
    config.headers["X-Admin-Pin"] = params.pin;
    const { pin, ...safeParams } = params;
    config.params = safeParams;
  }
  return config;
});

export const api = {
  stats: () => client.get(`/stats`).then((r) => r.data),
  categories: () => client.get(`/categories`).then((r) => r.data),
  services: () => client.get(`/services`).then((r) => r.data),
  config: () => client.get(`/config`).then((r) => r.data),
  paymentInfo: () => client.get(`/payment-info`).then((r) => r.data),
  resolveDomain: (host) => client.get(`/domains/resolve`, { params: { host } }).then((r) => r.data),

  listAds: (params) => client.get(`/ads`, { params }).then((r) => r.data),
  createAd: (body) => client.post(`/ads`, body).then((r) => r.data),
  getAd: (id) => client.get(`/ads/${id}`).then((r) => r.data),
  getAdLanding: (id) => client.get(`/ads/${id}/landing`).then((r) => r.data),

  packages: () => client.get(`/packages`).then((r) => r.data),
  createOrder: (body) => client.post(`/orders`, body).then((r) => r.data),
  redeemKey: (body) => client.post(`/keys/redeem`, body).then((r) => r.data),

  wallet: (email) => client.get(`/wallet/${encodeURIComponent(email)}`).then((r) => r.data),
  walletTopup: (body) => client.post(`/wallet/topup`, body).then((r) => r.data),

  aiChat: (body) => client.post(`/ai/chat`, body).then((r) => r.data),
  aiImage: (body) => client.post(`/ai/image`, body).then((r) => r.data),
  aiContract: (body) => client.post(`/ai/contract`, body).then((r) => r.data),
  aiPage: (body) => client.post(`/ai/page`, body).then((r) => r.data),
  aiBuilder: (body) => client.post(`/ai/builder`, body).then((r) => r.data),
  aiPublish: (body) => client.post(`/ai/publish`, body).then((r) => r.data),

  createSite: (body) => client.post(`/sites`, body).then((r) => r.data),
  getSite: (id) => client.get(`/sites/${id}`).then((r) => r.data),
  createAgent: (body) => client.post(`/agents`, body).then((r) => r.data),
  getAgent: (id) => client.get(`/agents/${id}`).then((r) => r.data),
  agentChat: (id, body) => client.post(`/agents/${id}/chat`, body).then((r) => r.data),
  getPage: (slug) => client.get(`/pages/${slug}`).then((r) => r.data),
  pages: () => client.get(`/pages`).then((r) => r.data),
  adminSites: (pin) => client.get(`/admin/sites`, { params: { pin } }).then((r) => r.data),
  adminDeleteSite: (id, pin) => client.delete(`/admin/sites/${id}`, { params: { pin } }).then((r) => r.data),
  adminAgents: (pin) => client.get(`/admin/agents`, { params: { pin } }).then((r) => r.data),
  adminDeleteAgent: (id, pin) => client.delete(`/admin/agents/${id}`, { params: { pin } }).then((r) => r.data),

  marketingAccounts: () => client.get(`/marketing/accounts`).then((r) => r.data),
  adminPutAccounts: (body, pin) => client.put(`/admin/marketing/accounts`, body, { params: { pin } }).then((r) => r.data),
  adminTestMarketingBridge: (pin) => client.post(`/admin/marketing/bridge/test`, {}, { params: { pin } }).then((r) => r.data),
  marketingGenerate: (body) => client.post(`/marketing/generate`, body).then((r) => r.data),
  supportChat: (body) => client.post(`/support/chat`, body).then((r) => r.data),
  adminVault: (pin) => client.get(`/admin/vault`, { params: { pin } }).then((r) => r.data),
  adminVaultSave: (body, pin) => client.post(`/admin/vault`, body, { params: { pin } }).then((r) => r.data),
  adminVaultDelete: (id, pin) => client.delete(`/admin/vault/${id}`, { params: { pin } }).then((r) => r.data),
  adminApikeys: (pin) => client.get(`/admin/apikeys`, { params: { pin } }).then((r) => r.data),
  adminApikeyGen: (body, pin) => client.post(`/admin/apikeys/generate`, body, { params: { pin } }).then((r) => r.data),
  adminApikeyRevoke: (code, pin) => client.post(`/admin/apikeys/${code}/revoke`, {}, { params: { pin } }).then((r) => r.data),
  adminMarketingPosts: (pin) => client.get(`/admin/marketing/posts`, { params: { pin } }).then((r) => r.data),
  adminSaveCampaign: (body, pin) => client.post(`/admin/marketing/campaign`, body, { params: { pin } }).then((r) => r.data),
  adminCampaigns: (pin) => client.get(`/admin/marketing/campaigns`, { params: { pin } }).then((r) => r.data),
  adminToggleCampaign: (id, pin) => client.post(`/admin/marketing/campaign/${id}/toggle`, {}, { params: { pin } }).then((r) => r.data),
  adminDeleteCampaign: (id, pin) => client.delete(`/admin/marketing/campaign/${id}`, { params: { pin } }).then((r) => r.data),
  adminRunCampaign: (id, pin) => client.post(`/admin/marketing/campaign/${id}/run`, {}, { params: { pin } }).then((r) => r.data),
  adminPublishMarketingPost: (id, pin) => client.post(`/admin/marketing/posts/${id}/publish`, {}, { params: { pin } }).then((r) => r.data),

  // admin (pin passed as query)
  adminLogin: (pin) => client.post(`/admin/login`, { pin }).then((r) => r.data),
  adminChangePin: (body) => client.put(`/admin/security/pin`, body).then((r) => r.data),
  adminOverview: (pin) => client.get(`/admin/overview`, { params: { pin } }).then((r) => r.data),
  adminPutCounters: (body, pin) => client.put(`/admin/counters`, body, { params: { pin } }).then((r) => r.data),
  adminOrders: (pin) => client.get(`/admin/orders`, { params: { pin } }).then((r) => r.data),
  adminConfirmOrder: (id, pin) => client.post(`/admin/orders/${id}/confirm`, {}, { params: { pin } }).then((r) => r.data),
  adminRejectOrder: (id, pin) => client.post(`/admin/orders/${id}/reject`, {}, { params: { pin } }).then((r) => r.data),
  adminAds: (pin) => client.get(`/admin/ads`, { params: { pin } }).then((r) => r.data),
  adminAdStatus: (id, status, pin) => client.post(`/admin/ads/${id}/status`, {}, { params: { status, pin } }).then((r) => r.data),
  adminReviewAd: (id, pin) => client.post(`/admin/ads/${id}/ai-review`, {}, { params: { pin } }).then((r) => r.data),
  adminDeleteAd: (id, pin) => client.delete(`/admin/ads/${id}`, { params: { pin } }).then((r) => r.data),
  adminKeys: (pin) => client.get(`/admin/keys`, { params: { pin } }).then((r) => r.data),
  adminGenKey: (params, pin) => client.post(`/admin/keys/generate`, {}, { params: { ...params, pin } }).then((r) => r.data),
  adminRevokeKey: (code, pin) => client.post(`/admin/keys/${code}/revoke`, {}, { params: { pin } }).then((r) => r.data),
  adminActivateKey: (code, pin) => client.post(`/admin/keys/${code}/activate`, {}, { params: { pin } }).then((r) => r.data),
  adminSavePackage: (body, pin) => client.post(`/admin/packages`, body, { params: { pin } }).then((r) => r.data),
  adminDeletePackage: (id, pin) => client.delete(`/admin/packages/${id}`, { params: { pin } }).then((r) => r.data),
  adminServices: (pin) => client.get(`/admin/services`, { params: { pin } }).then((r) => r.data),
  adminSaveService: (body, pin) => client.post(`/admin/services`, body, { params: { pin } }).then((r) => r.data),
  adminDeleteService: (id, pin) => client.delete(`/admin/services/${id}`, { params: { pin } }).then((r) => r.data),
  adminPages: (pin) => client.get(`/admin/pages`, { params: { pin } }).then((r) => r.data),
  adminSavePage: (body, pin) => client.post(`/admin/pages`, body, { params: { pin } }).then((r) => r.data),
  adminDeletePage: (id, pin) => client.delete(`/admin/pages/${id}`, { params: { pin } }).then((r) => r.data),
  adminDomains: (pin) => client.get(`/admin/domains`, { params: { pin } }).then((r) => r.data),
  adminDomainDNS: (pin) => client.get(`/admin/domains/dns`, { params: { pin } }).then((r) => r.data),
  adminSaveDomainDNS: (body, pin) => client.put(`/admin/domains/dns`, body, { params: { pin } }).then((r) => r.data),
  adminProvisionDomainDNS: (pin) => client.post(`/admin/domains/dns/provision`, {}, { params: { pin } }).then((r) => r.data),
  adminSaveDomain: (body, pin) => client.post(`/admin/domains`, body, { params: { pin } }).then((r) => r.data),
  adminDeleteDomain: (id, pin) => client.delete(`/admin/domains/${id}`, { params: { pin } }).then((r) => r.data),
  adminWalletAdjust: (body, pin) => client.post(`/admin/wallet/adjust`, body, { params: { pin } }).then((r) => r.data),
  adminAI: (body, pin) => client.post(`/admin/ai`, body, { params: { pin } }).then((r) => r.data),
  adminAIHistory: (sessionId, pin) => client.get(`/admin/ai/history`, { params: { session_id: sessionId, pin } }).then((r) => r.data),
  adminProjects: (pin) => client.get(`/admin/projects`, { params: { pin } }).then((r) => r.data),
  adminCloneProject: (id, pin) => client.post(`/admin/projects/${id}/clone`, {}, { params: { pin } }).then((r) => r.data),
  adminDownloadProject: (id, pin) => client.get(`/admin/projects/${id}/download`, { params: { pin }, responseType: "blob" }).then((r) => r.data),
  adminNotify: (body, pin) => client.post(`/admin/notify/telegram`, body, { params: { pin } }).then((r) => r.data),
  adminGetSettings: (pin) => client.get(`/admin/settings`, { params: { pin } }).then((r) => r.data),
  adminPutSettings: (body, pin) => client.put(`/admin/settings`, body, { params: { pin } }).then((r) => r.data),
  adminCategories: (pin) => client.get(`/admin/categories`, { params: { pin } }).then((r) => r.data),
  adminSaveCategory: (body, pin) => client.post(`/admin/categories`, body, { params: { pin } }).then((r) => r.data),
  adminDeleteCategory: (id, pin) => client.delete(`/admin/categories/${id}`, { params: { pin } }).then((r) => r.data),
  adminIntegrations: (pin) => client.get(`/admin/integrations`, { params: { pin } }).then((r) => r.data),
  adminTestIntegration: (provider, pin) => client.post(`/admin/integrations/test`, { provider }, { params: { pin } }).then((r) => r.data),
  adminAIEngines: (pin) => client.get(`/admin/ai-engines`, { params: { pin } }).then((r) => r.data),
  adminSaveAIEngine: (body, pin) => client.put(`/admin/ai-engines`, body, { params: { pin } }).then((r) => r.data),
  adminTestAIEngine: (capability, pin) => client.post(`/admin/ai-engines/test`, { provider: capability }, { params: { pin } }).then((r) => r.data),

  nbList: () => client.get(`/notebook/notebooks`).then((r) => r.data),
  nbCreate: (body) => client.post(`/notebook/notebooks`, body).then((r) => r.data),
  nbGet: (id) => client.get(`/notebook/notebooks/${id}`).then((r) => r.data),
  nbDelete: (id) => client.delete(`/notebook/notebooks/${id}`).then((r) => r.data),
  nbAddSource: (id, body) => client.post(`/notebook/notebooks/${id}/sources`, body).then((r) => r.data),
  nbDelSource: (id, sid) => client.delete(`/notebook/notebooks/${id}/sources/${sid}`).then((r) => r.data),
  nbChat: (id, body) => client.post(`/notebook/notebooks/${id}/chat`, body).then((r) => r.data),
  nbGenerate: (id, body) => client.post(`/notebook/notebooks/${id}/generate`, body).then((r) => r.data),
  nbDelNote: (id, noteid) => client.delete(`/notebook/notebooks/${id}/notes/${noteid}`).then((r) => r.data),
  nbAudio: (id, body) => client.post(`/notebook/notebooks/${id}/audio`, body).then((r) => r.data),
  nbVideo: (id, body) => client.post(`/notebook/notebooks/${id}/video`, body).then((r) => r.data),

  listProjects: (email) => client.get(`/projects`, { params: email ? { email } : {} }).then((r) => r.data),
  saveProject: (body) => client.post(`/projects`, body).then((r) => r.data),
  getProject: (id) => client.get(`/projects/${id}`).then((r) => r.data),
  deleteProject: (id) => client.delete(`/projects/${id}`).then((r) => r.data),
  createDomainRequest: (body) => client.post(`/domain-requests`, body).then((r) => r.data),
  adminDomainRequests: (pin) => client.get(`/admin/domain-requests`, { params: { pin } }).then((r) => r.data),
  adminApproveDomainReq: (id, pin) => client.post(`/admin/domain-requests/${id}/approve`, {}, { params: { pin } }).then((r) => r.data),
  adminRejectDomainReq: (id, pin) => client.post(`/admin/domain-requests/${id}/reject`, {}, { params: { pin } }).then((r) => r.data),

  adminGenCodes: (body, pin) => client.post(`/admin/codes/generate`, body, { params: { pin } }).then((r) => r.data),
  adminCodes: (pin, role) => client.get(`/admin/codes`, { params: { pin, ...(role ? { role } : {}) } }).then((r) => r.data),
  adminToggleCode: (code, pin) => client.post(`/admin/codes/${code}/toggle`, {}, { params: { pin } }).then((r) => r.data),
  adminRenewCode: (code, days, pin) => client.post(`/admin/codes/${code}/renew`, {}, { params: { days, pin } }).then((r) => r.data),
  adminDeleteCode: (code, pin) => client.delete(`/admin/codes/${code}`, { params: { pin } }).then((r) => r.data),

  createDeal: (body) => client.post(`/deals`, body).then((r) => r.data),
  advertiserLogin: (secret) => client.post(`/advertiser/login`, { secret }).then((r) => r.data),
  confirmDeal: (body) => client.post(`/deals/confirm`, body).then((r) => r.data),
  adminDeals: (pin) => client.get(`/admin/deals`, { params: { pin } }).then((r) => r.data),
  adminRegisterSections: (domain, pin) => client.post(`/admin/register-sections`, { domain }, { params: { pin } }).then((r) => r.data),
};

// local helpers for unlocked services + current user email
export const local = {
  getEmail: () => localStorage.getItem("aql4_email") || "",
  setEmail: (e) => localStorage.setItem("aql4_email", e),
  getUnlocked: () => JSON.parse(localStorage.getItem("aql4_unlocked") || "[]"),
  setUnlocked: (arr) => localStorage.setItem("aql4_unlocked", JSON.stringify(arr)),
  addUnlocked: (services) => {
    const cur = new Set(local.getUnlocked());
    services.forEach((s) => cur.add(s));
    local.setUnlocked([...cur]);
  },
};
